// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriberConfirmPage_container__s2jom"};